export default __webpack_public_path__ + "static/media/failedLogo.c1d6cce9.svg";